import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { GridApi, GridOptions, IDatasource, IGetRowsParams } from 'ag-grid-community';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CommonService } from 'src/app/services/common-service/common.service';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ButtonRendererComponent } from 'src/app/components/renderer/button-renderer.component';
import { ColumnHeader } from 'src/app/models/column-header';
import { SrcPath } from 'src/app/constants/srcPath';
import { roleTypeOptions, dateTypeOptions } from 'src/app/utils/utils';
import { ConfirmModalComponent } from 'src/app/components/modal/confirm-modal/confirm-modal.component';
import { Labels } from 'src/app/constants/labels';
import { ToastrService } from 'ngx-toastr';
import { KEYS } from 'src/app/constants/keys';
import { AddCustomerComponent } from 'src/app/components/modal/add-customer/add-customer.component';
import { Router } from '@angular/router';
import { RoutePath } from 'src/app/constants/routerPath';
import $ from 'jquery';
import { isPresent } from 'src/app/utils/utils';
import { isNullOrUndefined } from 'is-what';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { ColumnHeaderComponent } from 'src/app/components/column-header/column-header.component';
import { IconBlockSettingsComponent } from 'src/app/components/icon-block-settings/icon-block-settings.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { SharedModule } from 'src/app/shared/shared.module';
@Component({
  selector: 'app-customer',
  standalone: true,
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, NgSelectModule,AgGridAngular, AgGridModule, ColumnHeaderComponent,SharedModule]
})
export class CustomerComponent implements OnInit {

  roleTypeOption = roleTypeOptions;
  dateTypeOption = dateTypeOptions;
  headerData!: ColumnHeader;
  public userdetails: any = [];
  public gridOptions: GridOptions;
  keys = KEYS.customerPermission;
  pageLabel = Labels.customer;
  customerForm!: FormGroup;
  submitted = false;
  modalRef!: BsModalRef;
  menuTemplate: any = [];
  selectedModules: any = [];
  canCreateModule = 0;
  canCreatePage = 0;
  editCustomerFlag: boolean = false;
  buttonValue!: string;
  labelMessages = Labels.messages;
  @ViewChild('customerModal') templateRef!: TemplateRef<any>;
  customerList: any;
  customerEdit: any;
  checkArray1: any;
  editData: any = [];
  isSuperaDmin: boolean = false;
  customerLanguage: any = [];
  messageLabel = Labels.messages;
   gridOptionscolumnDefs: any[] = [];
    public gridOptionsApi: GridApi | any;
  defaultColDef: { sortable: boolean; filter: boolean; floatingFilter: boolean; resizable: boolean; };
  constructor(private router: Router, private toastr: ToastrService, private fb: FormBuilder, public modalService: BsModalService, private authService: AuthService, private commonService: CommonService, public http: HttpClient) {
     this.gridOptions = <GridOptions>{
      rowModelType: 'infinite',
      rowSelection: 'single',
      onCellClicked: (event: any) => {
        console.log('called getcell', event.data);
        this.viewDashboard(event)
      },
      context: { componentParent: this }
    }
    this.defaultColDef = {
      sortable: true,
      filter: true,
      floatingFilter: true,
      resizable: true
    }
    this.gridOptionscolumnDefs = [
      { field: 'SI', sortable: true, valueGetter: "node.rowIndex+1", width: 50, resizable: true },
      { field: 'customer', sortable: true, filter: true, floatingFilter: true, resizable: true },
      { field: 'company', sortable: true, filter: true, floatingFilter: true, resizable: true },
      { field: 'email', sortable: true, filter: true, floatingFilter: true, resizable: true },
      { field: 'phone', sortable: true, filter: true, floatingFilter: true, resizable: true },
      { field: 'address', sortable: true, filter: true, floatingFilter: true, resizable: true },
      { field: 'date_format', sortable: true, filter: true, floatingFilter: true, resizable: true },
      { field: 'role', sortable: true, filter: true, floatingFilter: true, resizable: true },
      { field: 'db_url', sortable: true, filter: true, floatingFilter: true, resizable: true, hide: true },
      { field: 'language', sortable: true, filter: true, floatingFilter: true, resizable: true, hide: true },
      {
        headerName: 'Edit',
        width: 60,
        cellRenderer: ButtonRendererComponent,
        cellRendererParams: {
          onClick: this.editCustomer.bind(this),
          label: 'edits'
        },
      },
      {
        headerName: 'Delete',
        width: 80,
        cellRenderer: ButtonRendererComponent,
        cellRendererParams: {
          onClick: this.deleteCustomer.bind(this),
          label: 'trash'
        }
      }
    ]

this.gridOptions.columnDefs = this.gridOptionscolumnDefs;
    this.gridOptions.suppressHorizontalScroll = true;
    //this.gridOptions.rowData = [];
      this.gridOptions.rowSelection = 'single';
      //this.gridOptions.onCellClicked = this.viewDashboard.bind(this)

  }

  ngOnInit(): void {
    
    this.isSuperAdmin();
    this.checkIconBlock();
    this.submitted = false;
    this.editCustomerFlag = false;
    this.userdetails = JSON.parse(sessionStorage.getItem(KEYS.user_credential)!);
    //this.initcustomerForm();
    this.loadMenuModules();
    this.loadLanguage();
    this.headerData = {
      title: this.pageLabel.title,
      button: {
        show: false
      },
      topButton: {
        show: true,
        property: [
          {
            title: this.pageLabel.buttontitle,
            icon: SrcPath.addIcon,
            class: this.pageLabel.class
          }
        ]
      }
    };
  }
  isSuperAdmin() {
    let isCredData = isPresent(JSON.parse(sessionStorage.getItem(KEYS.user_credential)!));
    if (isCredData) {
      let credData = JSON.parse(sessionStorage.getItem(KEYS.user_credential)!);
      if (credData.user_Type == 1 || credData.user_Type == 3) {
        this.isSuperaDmin = true;
      } else {
        this.isSuperaDmin = false;
      }
    }
  }
  checkIconBlock() {
    var findClass = $(".iconBlock").parent().parent().find('app-customer');
    if (findClass.length > 0) {
      $('.iconBlock').css('display', 'none');
    }
  }

  loadCatlog() {
    this.commonService.getCustomerData().subscribe((data: any) => {
      this.commonService.ogLog('data_cs:', data['table'])
      if (data['table']) {
        let datas = data['table'];
        this.customerList = data['table'];


        datas.forEach((element: any) => {
          let roleName = element.gstibo_role == 2 ? 'Admin' : 'User';
          this.gridOptions.rowData?.push(
            {
              'id': element.gstibo_customer_id,
              'customer': element.gstibo_customer_name,
              'company': element.gstibo_company_name,
              'email': element.gstibo_email,
              'phone': element.gstibo_contact_phone,
              'address': element.gstibo_contact_address,
              'date_format': element.gstibo_date_format,
              'role': roleName,
              //'db_url': element.gstibo_api_url,
              'language': element.gstibo_language,
              'screenMode': element.gstibo_screenview_mode == null ? 'Standard' : element.gstibo_screenview_mode
            }
          );
        });

      }

      this.commonService.ogLog(this.gridOptions.rowData, "data")
      //this.gridOptionsApi.setRowData(this.gridOptions.rowData);
    })
  }

  onSortChanged(e:any) {
    e.api.refreshCells();
  }
  onGridReady(params: any) {
     this.gridOptionsApi = params.api;
    this.gridOptionsApi.sizeColumnsToFit();
     const datasource: IDatasource = {
      getRows: (rowParams: IGetRowsParams) => {
        console.log('called getrows', rowParams);
        this.commonService.getCustomerData().subscribe({
          next: (datass: any) => {
            const table = datass?.['table'] || null;
            if (table.length == 0) {
              this.gridOptionsApi.showNoRowsOverlay();
            }

            const rowData = table.map((element: any) => ({
              'id': element.gstibo_customer_id,
              'customer': element.gstibo_customer_name,
              'company': element.gstibo_company_name,
              'email': element.gstibo_email,
              'phone': element.gstibo_contact_phone,
              'address': element.gstibo_contact_address,
              'date_format': element.gstibo_date_format,
              'role': element.gstibo_role == 2 ? 'Admin' : 'User',
              //'db_url': element.gstibo_api_url,
              'language': element.gstibo_language,
              'screenMode': element.gstibo_screenview_mode == null ? 'Standard' : element.gstibo_screenview_mode
            }));
            const start = rowParams.startRow;
            const end = rowParams.endRow;
            const rowthisBlock = rowData.slice(start, end);
            const lastRow = (rowData.length <= end) ? rowData.length : -1;
            rowParams.successCallback(rowthisBlock, lastRow);
          },
          error: (err) => {
            console.log('errrrr', err);
            rowParams.failCallback();
          }
        });
      }
    }
    params.api.setGridOption('datasource', datasource);
    this.loadCatlog();
  }
  openModal(id: any) {
    if (id == 0) this.editCustomerFlag = false
    this.commonService.setCustomerModuleData(this.menuTemplate);
    this.commonService.setLanguageData(this.customerLanguage);
    this.submitted = false;
    const config: ModalOptions = { class: KEYS.modalConfigClass, backdrop: "static" }
    if (this.editCustomerFlag == true) {
      this.modalRef = this.modalService.show(AddCustomerComponent, config);
      this.modalRef.content.formSubmitEvent.subscribe((res: any) => {
        if (res) {
          this.updateCustomerModel(res)
        }
      });
    } else {
      this.commonService.clearCustomerData();
      this.modalRef = this.modalService.show(AddCustomerComponent, config);
      this.modalRef.content.formSubmitEvent.subscribe((res: any) => {
        if (res) {
          this.addCustomerModel(res)
        }
      });
    }


  }

  addCustomerModel(customerModel: any) {

    if (customerModel.createmodule == true) { this.canCreateModule = this.keys.createmodule; }
    else { this.canCreateModule = this.keys.createNomodule; }
    if (customerModel.createpage == true) { this.canCreatePage = this.keys.createpage; }
    else { this.canCreatePage = this.keys.createNopage; }
    // this.commonService.selectModuleEmitter.subscribe(selectedModules => {
    //   this.selectedModules = selectedModules;
    // })
    if (isPresent(customerModel.imgFiles)) {
      const curTime = (new Date().toLocaleDateString().replace("/", "")).replace("/", "") + new Date().getTime();
      const fname = customerModel.imgFiles.name;
      const extension = fname.slice((Math.max(0, fname.lastIndexOf(".")) || Infinity) + 1);
      const filesaved = curTime + '.' + extension;
      let fullpath = "uploadFiles/gstiusa/" + this.commonService.getUserCredentials(KEYS.credential_account_id) + "/" + filesaved;
      // fullpath = (((fullpath.replace("/", "~")).replace("/", "~")).replace("/", "~")).replace("/", "~");
      customerModel.imgUrl = fullpath;
      this.commonService.ogLog('errorstart', customerModel.imgFiles, curTime, this.commonService.getUserCredentials(KEYS.credential_account_id))
      this.commonService.uploadManageUserProfile(customerModel.imgFiles, curTime, this.commonService.getUserCredentials(KEYS.credential_account_id)).subscribe(data => {
        this.commonService.ogLog('uploadManageUserProfile : ', data);
        this.AddCustomer(customerModel);
      }, error => {
        this.AddCustomer(customerModel);
        console.log('Error!', error);
      });
    }
    else {
      this.AddCustomer(customerModel);
    }
  }
  AddCustomer(customerModel: any) {
    this.commonService.saveCustomer(customerModel, this.canCreateModule, this.canCreatePage).subscribe((data: any) => {
      if (data['table']) {
        this.commonService.ogLog(data);

        let Data = data['table'];
        let customer_id = "";
        if (Data.length > 0) {
          customer_id = Data[0].primary_key;
        }
        if (!isNullOrUndefined(customerModel.menuTemp) && customerModel.menuTemp.length > 0) {
          customerModel.menuTemp.forEach((element: any) => {
            this.saveCustomerModule(this.editData, element);
          });
        }
        this.gridOptions.rowData = [];
        this.ngOnInit();
        this.loadCatlog();
        //this.toastr.success(this.labelMessages.save_success_msg.message);
        this.commonService.showModalValidate(this.labelMessages.save_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.save_success_msg.message);
      }
    },
      error => {
        console.log('Save Customer Error:', error);
      });
  }
  saveCustomerModule(customer_id:any, module_id:any) {
    if (customer_id != '' && module_id != '') {

      this.commonService.saveCustomerModule(customer_id, module_id).subscribe(data => {
      },
        error => {
          console.log('saveCustomerModule Error:', error);
        });
    }
  }
  viewDashboard(e:any) {
    if (e.column.colDef.headerName == 'Delete') {
    }
    else if (e.column.colDef.headerName == 'Edit') {
    }
    else {
      if (this.isSuperaDmin) {
        let customerLanguage = e.data.language;
        sessionStorage.setItem(KEYS.customerLanguage, JSON.stringify(customerLanguage));
        sessionStorage.removeItem(KEYS.customerDateFormat);
        sessionStorage.setItem(KEYS.customerDateFormat, e.data.date_format);
        this.editData = e.data.id;
        this.commonService.setAdminSelectedTopMenu('Dashboard');
        let adminSelectedTopMenu = this.commonService.getAdminSelectedTopMenu();
        this.router.navigate([RoutePath.dashboard],
          {
            queryParams: {
              customerId: this.editData,
              db_path: e.data.db_url
            }
          });
      }
    }
  }
  editCustomer(e: any) {
    this.editCustomerFlag = true;
    this.editData = e.rowData.id
    //this.commonService.editCustomerEmitter.emit(e.rowData.id);
    this.customerEdit = this.customerList.filter((id: any) => id.gstibo_customer_id == this.editData);
    //this.commonService.editCustomerDataEmitter.emit( this.customerEdit);
    this.commonService.setEditCustomerData(this.customerEdit);
    this.openModal(e.rowData.id)

  }
  updateCustomerModel(customerModel: any) {
    if (customerModel.createmodule == true) { this.canCreateModule = this.keys.createmodule; }
    else { this.canCreateModule = this.keys.createNomodule; }
    if (customerModel.createpage == true) { this.canCreatePage = this.keys.createpage; }
    else { this.canCreatePage = this.keys.createNopage; }
    if (isPresent(customerModel.imgFiles)) {
      const curTime = (new Date().toLocaleDateString().replace("/", "")).replace("/", "") + new Date().getTime();
      const fname = customerModel.imgFiles.name;
      const extension = fname.slice((Math.max(0, fname.lastIndexOf(".")) || Infinity) + 1);
      const filesaved = curTime + '.' + extension;
      let fullpath = "uploadFiles/gstiusa/" + this.commonService.getUserCredentials(KEYS.credential_account_id) + "/" + filesaved;
      // fullpath = (((fullpath.replace("/", "~")).replace("/", "~")).replace("/", "~")).replace("/", "~");
      customerModel.imgUrl = fullpath;
      this.commonService.ogLog('errorstart', customerModel.imgFiles, curTime, this.commonService.getUserCredentials(KEYS.credential_account_id))
      this.commonService.uploadManageUserProfile(customerModel.imgFiles, curTime, this.commonService.getUserCredentials(KEYS.credential_account_id)).subscribe(data => {
        this.commonService.ogLog('uploadManageUserProfile : ', data);
        this.saveCustomer(customerModel);
      }, error => {
        this.saveCustomer(customerModel);
        console.log('Error!', error);
      });
    }
    else {
      this.saveCustomer(customerModel);
    }

  }
  saveCustomer(customerModel: any) {
    this.commonService.updateCustomer(customerModel, this.canCreateModule, this.canCreatePage, this.editData).subscribe(data => {
      this.commonService.ogLog(data);
      this.deleteCustomerModule(this.editData);
      if (!isNullOrUndefined(customerModel.menuTemp) && customerModel.menuTemp.length > 0) {
        customerModel.menuTemp.forEach((keyelement: any) => {
          this.saveCustomerModule(this.editData, keyelement);
        });
      }
      this.gridOptions.rowData = [];
      this.ngOnInit();
      this.loadCatlog();
     // this.toastr.success(this.labelMessages.update_success_msg.message);
     this.commonService.showModalValidate(this.labelMessages.update_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.update_success_msg.message);
    }, error => {
      console.log('Error!', error);
    });
  }

  deleteCustomerModule(customer_id: any) {
    if (customer_id != '') {

      this.commonService.deleteCustomerModule(customer_id).subscribe(data => {

      },
        error => {
          console.log('saveCustomerModule Error:', error);
        });
    }
  }
  deleteCustomer(e: any) {
    let customerId = e.rowData.id;
    this.modalRef = this.modalService.show(ConfirmModalComponent, {
      animated: true, class: KEYS.confirmModal
    });
    this.modalRef.content.data = {
      title: 'Confirm',
      message: this.labelMessages.delete_confirm_msg.message,
      btnConfirm: 'Yes',
      btnCancel: 'Cancel',
      btnConfirmStyle: 'btn-red',
      btnCancelStyle: 'btn-green'
    }
    this.modalRef.content.buttonevent.subscribe((res: any) => {
      if (res) {
        this.commonService.deleteCustomer(customerId).subscribe(data => {
          this.gridOptions.rowData = [];
          this.ngOnInit();
          this.loadCatlog();
          //this.toastr.success(this.labelMessages.delete_success_msg.message);
          this.commonService.showModalValidate(this.labelMessages.delete_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.delete_success_msg.message);
        });
      }
    });
  }

  loadMenuModules() {
    //this.menuTemplate = [];
    let userdetails = JSON.parse(sessionStorage.getItem(KEYS.user_credential)!);
    this.selectedModules = [];
    this.commonService.getMenuModule(userdetails.gstibo_customer_id).subscribe((data: any) => {
      if (data['table']) {
        let datas = data['table'];
        let parentmenus = data['table'].filter((x: any) => x.gstibo_parent_menu_id == 0);
        this.menuTemplate = [];
        parentmenus.forEach((element: any) => {
          this.menuTemplate.push(
            {
              'gstibo_menu_name': element.gstibo_menu_name,
              'gstibo_menu_id': element.gstibo_menu_id,
              'is_selected': (this.selectedModules.includes(element.gstibo_menu_id) ? true : false)
            }
          );
        });
        this.commonService.loadModuleEmitter.emit(this.menuTemplate);
      } else {
        this.commonService.ogLog('data not available');
      }
    },
      error => {
        console.log('executeLogicAppsApi Error:', error);
      });
  }

  loadLanguage() {

    this.commonService.loadLanguages().subscribe((data: any) => {
      // console.log('data : ', data['table']);
      if (data['table'].length > 0) {
        this.customerLanguage = [];
        data['table'].forEach((element: any) => {
          this.customerLanguage.push({
            'id': element.gstibo_ln_code,
            'name': element.gstibo_ln_name
          });
        });
        sessionStorage.setItem(KEYS.dbLanguages, JSON.stringify(this.customerLanguage));
        // console.log('this.customerLanguage:', this.customerLanguage);
        this.commonService.loadLanguageEmitter.emit(this.customerLanguage);
      }
    });
  }

}
